import type { SVGProps } from 'react';

const SvgMultiStepForm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="multi-step-form">
      <path d="M27.66 23.92V8.58A2.72 2.72 0 0 0 25 5.86h-.34v1.5H25a1.21 1.21 0 0 1 1.21 1.22v15.34A1.22 1.22 0 0 1 25 25.14H7.22A1.22 1.22 0 0 1 6 23.92v-.7H4.51v.7a2.72 2.72 0 0 0 2.71 2.72H25a2.72 2.72 0 0 0 2.66-2.72" />
      <path d="M29 10.56h-.3v1.5h.3a1.22 1.22 0 0 1 1.22 1.22v15.34A1.22 1.22 0 0 1 29 29.84H11.31a1.22 1.22 0 0 1-1.22-1.22v-.7h-1.5v.7a2.72 2.72 0 0 0 2.72 2.72H29a2.72 2.72 0 0 0 2.72-2.72V13.28A2.72 2.72 0 0 0 29 10.56" />
      <path d="M23.41 19.23V3.17A2.72 2.72 0 0 0 20.69.45H3A2.72 2.72 0 0 0 .25 3.17v16.06A2.72 2.72 0 0 0 3 22h17.69a2.72 2.72 0 0 0 2.72-2.77m-21.66 0V3.17A1.22 1.22 0 0 1 3 2h17.69a1.22 1.22 0 0 1 1.22 1.22v16.01a1.22 1.22 0 0 1-1.22 1.22H3a1.22 1.22 0 0 1-1.25-1.22" />
      <path d="M18 4.75H5.67a.74.74 0 0 0-.75.75v5.7a.75.75 0 0 0 .75.75H18a.75.75 0 0 0 .75-.75V5.5a.74.74 0 0 0-.75-.75m-.75 5.7H6.42v-4.2h10.82ZM5.56 14.96h12.53v1.5H5.56z" />
    </g>
  </svg>
);

export default SvgMultiStepForm;
